export function getCustomerCode(state = {}) {
  return state.customerCode;
}
